/** Player API functions */

/** voulume storage key */
const VOLUME_KEY = "volume";
/** muted storage key */
const MUTED_KEY = "muted";
const MUTED_ON = "on";
const MUTED_OFF = "off";

/**
 * Save volume to local storage
 * @param {Number} volume volume in range [0-1]
 */
export const saveVolume = volume => {
  if (!isFinite(volume) || volume > 1 || volume < 0) {
    console.warn("Player volume must be number in range 0-1");
    return;
  }

  localStorage.setItem(VOLUME_KEY, volume);
};

/**
 * Save muted state to local storage
 * @param {Boolean} muted muted flag
 */
export const saveMuted = muted => {
  const mutedValue = muted ? MUTED_ON : MUTED_OFF;
  localStorage.setItem(MUTED_KEY, mutedValue);
};

/**
 * Get volume from local storage
 * @returns volume number in range [0-1] or NaN (if volume not saved)
 */
export const restoreVolume = () => {
  const volume = localStorage.getItem(VOLUME_KEY);

  if (volume == null) return NaN;

  return Number(volume);
};

/**
 * Get muted from local storage
 * @returns muted boolean flag or null (if volume not saved)
 */
export const restoreMuted = () => {
  const mutedString = localStorage.getItem(MUTED_KEY);

  if (mutedString == MUTED_ON || mutedString == MUTED_OFF) {
    return mutedString == MUTED_ON;
  }

  return null;
};
